import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import classNames from 'classnames';
import isString from 'lodash/isString';

import Button from '@adsk/bim360-matrix-react-button';
import AnimateHeight from '@adsk/bim360-matrix-react-animate-height';

import linkifyText from '@adsk/bim360-matrix-react-helpers/es/linkifyText';
import { withLocale, TSymbolProp } from '@adsk/bim360-matrix-react-helpers/es/locale';

import './_LongTextActivityLine.scss';
import { ThemeConsumer } from '@adsk/bim360-matrix-react-helpers/es/theme';

export class LongTextActivityLine extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false
    };
  }

  toggleExpanded() {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  getToggleButtonLabel() {
    return this.state.isExpanded
      ? this.props[TSymbolProp].translate('HIDE')
      : this.props[TSymbolProp].translate('SHOW');
  }

  render() {
    const fieldValue = isString(this.props.fieldValue)
      ? this.props.fieldValue.replace(/\r?\n/g, '<br/>')
      : this.props.fieldValue;
    return (
      <ThemeConsumer>
        {({ theme }) => (
          <div
            className={classNames(
              'LongTextActivityLine',
              this.props.className,
              `LongTextActivityLine--${theme}`
            )}
          >
            <span className="LongTextActivityLine__field-name">{this.props.fieldName}</span>
            <Button
              styleType={Button.StyleType.LINK}
              className="LongTextActivityLine__button"
              onClick={() => this.toggleExpanded()}
            >
              {this.getToggleButtonLabel()}
            </Button>
            <AnimateHeight isOpen={this.state.isExpanded} height={'0px'} timeout={300}>
              <div className="LongTextActivityLine__field-value">
                <div dangerouslySetInnerHTML={{ __html: linkifyText(fieldValue) }} />
              </div>
            </AnimateHeight>
          </div>
        )}
      </ThemeConsumer>
    );
  }
}

LongTextActivityLine.propTypes = {
  /**
   * Class name to append to the container of this component
   */
  className: PropTypes.string,
  /**
   * The title of the changed field
   */
  fieldName: PropTypes.string.isRequired,
  /**
   * A string or React node of the changed field's value
   */
  fieldValue: PropTypes.string.isRequired,
  /**
   * The locale to use for the show/hide button.
   */
  locale: PropTypes.string
};

export default withLocale(
  LongTextActivityLine,
  ({ locale }) => new MDText(require(`./i18n/${locale}.json`))
);
